import React, { useState } from 'react'
import classes from './LayoutHeader.module.css'
import ManageLogo from '../../../../assets/img/images/manage-asiacommerce.png'
import { Box, Burger, Flex, Text, Avatar, Menu, Group, NavLink, ThemeIcon, Divider, ScrollArea, Modal, Badge, Loader } from '@mantine/core'
import { useSelector, useDispatch } from 'react-redux'
import { IconDoorExit, IconChevronDown, IconPencil, IconDotsVertical } from '@tabler/icons-react'
import { useNavigate, useLocation } from 'react-router-dom'
import { logout } from '../../../../services/auth'
import Cookies from 'universal-cookie'
import { updateDataLogin } from '../../../../store/authData'
import { readLocalStorageValue } from '@mantine/hooks'
import { authRoutes } from '../../../../routes'
import { useViewportSize } from '@mantine/hooks'
import NetralAvatar from '../../../../assets/img/avatar/netral-avatar.png'
import MaleAvatar from '../../../../assets/img/avatar/male-avatar.png'
import FemaleAvatar from '../../../../assets/img/avatar/female-avatar.png'
import FormAdjustAvatar from './Form/FormAdjustAvatar'
import { getAuthUserLogin } from '../../../../store/userLogin'
import { notificationError } from '../../Notifications'
import { setOnlineStatusUser } from '../../../../services/users'

const onlineStatusList = [
  { value: 'online', color: 'green' },
  { value: 'away', color: 'yellow' },
  { value: 'invisible', color: 'gray' },
]

const LayoutHeader = ({ mobileToggle, desktopToggle }) => {
  const { pathname } = useLocation()
  const { width } = useViewportSize()
  const layoutValue = readLocalStorageValue({ key: 'manage-app-layout' })
  const cookies = new Cookies()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const dataLogin = useSelector(state => state.auth.authorization)
  const detailUser = useSelector(state => state.user_login.data)
  const loadingUser = useSelector(state => state.user_login.isLoadingUser)
  const [openModalAvatar, setOpenModalAvatar] = useState(false)
  const [detailData, setDetailData] = useState(null)

  // online status
  const [loadingOnlineStatus, setLoadingOnlineStatus] = useState(false)
  const handleSetOnlineStatus = async (status) => {
    setLoadingOnlineStatus(true)
    try {
      const response = await setOnlineStatusUser({ status })
      if (response.success) {
        dispatch(getAuthUserLogin())
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message
      notificationError('Set Status Error', `${errorMessage ? errorMessage : 'Please try again later'}`)
    } finally {
      setLoadingOnlineStatus(false)
    }
  }

  const logoutUser = async () => {
    const response = await logout()
    if (response.success) {
      navigate('/login')
      dispatch(updateDataLogin({ 'authorization': null, 'isLogin': false, 'isLoading': false }))
      cookies.remove('manage-session')
    }
  }

  const handleChangeAvatar = (event, detailUser) => {
    event.stopPropagation()
    setOpenModalAvatar(true)
    setDetailData(detailUser.attributes)
  }

  const onCloseModalAvatarForm = () => {
    setOpenModalAvatar(false)
    setDetailData(null)
  }

  const mappingMenuHeader = (dataRoute) => {
    // eslint-disable-next-line
    const remapRoute = () => dataRoute.map((val, index) => {
      if (val.type === 'route') {
        return (
          <NavLink
            key={index}
            label={
              <Text
                c={val.route === pathname ? 'red' : 'black'}
                fw={val.route === pathname ? '600' : '400'}
                fz={13}
                tt='capitalize'
              >
                {val.name}
              </Text>
            }
            leftSection={<ThemeIcon color={val.route === pathname ? 'red' : 'black'} variant='white' radius="md" size={20}>{val.icon}</ThemeIcon>}
            mb={8}
            onClick={(event) => {
              event.preventDefault()
              navigate(`${val.route}`)
            }}
            style={{ width: 'auto' }}
          />
        )
      } else if (val.type === 'group') {
        const mappingGroupMenu = (childrenRoute) => {
          if (childrenRoute.length > 0) {
            // eslint-disable-next-line
            const mappingMenu = childrenRoute.map((val, index) => {
              if (
                val.name !== 'detail order' &&
                val.name !== 'detail user' &&
                val.name !== 'add product catalog' &&
                val.name !== 'add product manual' &&
                val.name !== 'detail product' &&
                val.name !== 'add order' &&
                val.name !== 'detail package shipment' &&
                val.name !== 'Set International Shipping Rates'
              ) {
                return (
                  <Menu.Item
                    color={val.route === pathname ? 'red' : 'gray.9'}
                    onClick={(event) => {
                      event.preventDefault()
                      navigate(val.route)
                    }}
                    fw={val.route === pathname ? '600' : '400'}
                  >
                    <Text c={val.route === pathname ? 'red' : 'gray.9'} fw={val.route === pathname ? '600' : '400'} fz={13} tt='capitalize'> {val.name}</Text>
                  </Menu.Item>
                )
              }

            })
            return mappingMenu
          }
        }

        return (
          <Menu trigger="click-hover" openDelay={100} closeDelay={400} position='bottom-start' width={220} fz={13}>
            <Menu.Target>
              <NavLink
                key={index}
                label={
                  <Text
                    c={val.children.find((val) => val.route === pathname) || val.route === pathname ? 'red' : 'black'}
                    fw={val.children.find((val) => val.route === pathname) || val.route === pathname ? '600' : '400'}
                    fz={13}
                    tt='capitalize'
                  >
                    {val.name}
                  </Text>
                }
                leftSection={<ThemeIcon color={val.children.find((val) => val.route === pathname) || val.route === pathname ? 'red' : 'black'} variant='white' radius="md" size={20}>{val.icon}</ThemeIcon>}
                rightSection={<IconChevronDown size={14} stroke={1.5} />}
                mb={8}
                style={{ width: 'auto' }}
                onClick={(e) => {
                  if (val.route) {
                    e.preventDefault()
                    navigate(val.route)
                  }
                }}
              />
            </Menu.Target>
            <Menu.Dropdown>
              {mappingGroupMenu(val.children)}
            </Menu.Dropdown>
          </Menu>
        )
      }
    })
    return (
      <Box>
        <Divider mb={6} />
        <ScrollArea maw={width} offsetScrollbars overscrollBehavior="none" scrollbarSize={4} mx='auto' scrollbars="x">
          <Group gap={0} visibleFrom="sm" style={{ width: 'max-content', overflowX: 'hidden' }} mx={20}>
            {remapRoute()}
          </Group>
        </ScrollArea>
      </Box>
    )
  }

  const mappingUserLogin = (data, detailUser) => {
    if (data !== null && detailUser !== null) {

      const handleAvatarUser = (detail) => {
        const dataUser = detail.attributes
        if (dataUser.images === null) {
          if (dataUser.gender === null) {
            return NetralAvatar
          } else if (dataUser.gender === 'male') {
            return MaleAvatar
          } else if (dataUser.gender === 'female') {
            return FemaleAvatar
          }
        } else {
          return dataUser.images
        }
      }

      return (
        <Group gap={'md'}>
          <Menu position='bottom-end' offset={3} withArrow>
            <Menu.Target>
              <Group gap={10} style={{ cursor: 'pointer' }}>
                <Badge
                  size={10}
                  circle
                  color={
                    detailUser?.attributes?.online_status === 'away' ? 'yellow'
                      : detailUser?.attributes?.online_status === 'online' ? 'green'
                        : 'gray'
                  }
                />
                <Text fz={12} fw={500} tt='capitalize'>{detailUser?.attributes?.online_status || 'Not set status'}</Text>
                {loadingOnlineStatus || loadingUser ? <Loader color="gray" size={12} /> : <IconDotsVertical color='gray' size={12} />}
              </Group>
            </Menu.Target>
            <Menu.Dropdown>
              {onlineStatusList.map((status) => (
                <Menu.Item key={status.value} onClick={() => handleSetOnlineStatus(status.value)}>
                  <Group gap={10}>
                    <Badge size={10} color={status.color} circle />
                    <Text fz={12} fw={500} tt="capitalize" c={'gray'}>{status.value}</Text>
                  </Group>
                </Menu.Item>
              ))}
            </Menu.Dropdown>
          </Menu>

          <Menu position='bottom-end' offset={3} withArrow>
            <Menu.Target>
              <Box style={{ cursor: 'pointer' }}>
                <Flex align="center" gap='sm'>
                  <Box pos='relative'>
                    <Avatar src={handleAvatarUser(detailUser)} radius="xl" size="md" onClick={(e) => handleChangeAvatar(e, detailUser)} style={{ border: '1.2px solid red', cursor: 'pointer' }} />
                    <ThemeIcon variant="filled" radius="xl" size={16} style={{ position: 'absolute', bottom: '0', right: '0' }}>
                      <IconPencil style={{ width: '70%', height: '70%' }} />
                    </ThemeIcon>
                  </Box>
                  <Box>
                    <Text fw='600' fz={12}>{data.user.name}</Text>
                    <Text fz={12}>{data.user.email}</Text>
                  </Box>
                  <IconChevronDown size="1rem" />
                </Flex>
              </Box>
            </Menu.Target>
            <Menu.Dropdown style={{ border: '0px', padding: '0px', borderRadius: '10px', boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px' }}>
              <Box style={{ width: '16rem', padding: '6px' }}>
                <Box>
                  <Menu.Divider />
                  <Menu.Item color='red' leftSection={<IconDoorExit size={14} />} onClick={() => logoutUser()}>Logout</Menu.Item>
                </Box>
              </Box>
            </Menu.Dropdown>
          </Menu>
        </Group>
      )
    }
  }

  return (
    <Box>
      <header className={classes.root}>
        <Box className={classes.sectionHeader}>
          <Flex gap='md' align='center' wrap='nowrap'>
            <Burger onClick={mobileToggle} hiddenFrom='sm' size='md' />
            {layoutValue === 'nav-sidebar' ? <Burger onClick={desktopToggle} visibleFrom='sm' size={22} /> : ''}
            <img src={ManageLogo} width='160' alt='manage-logo' />
          </Flex>
          <Box>
            {mappingUserLogin(dataLogin, detailUser)}
          </Box>
        </Box>
        {layoutValue === 'nav-header' ? mappingMenuHeader(authRoutes) : ''}
      </header>
      <Modal opened={openModalAvatar} onClose={onCloseModalAvatarForm} centered closeOnClickOutside={false} size='md' title={<Text fw='Bold'>Change Avatar Profile</Text>} withCloseButton={false}>
        <FormAdjustAvatar dataAvatar={detailData} onCloseForm={onCloseModalAvatarForm} />
      </Modal>
    </Box>

  )
}

export default LayoutHeader